import MainSection from "../components/mainsection";
import Product from "../components/product";
import UserData from "../components/data";

const Home =()=>{
    return(
        <>
           <MainSection/>
           <Product/>
            <UserData/> 
        </>
    )
}

export default Home;
